import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod'
import { catchError } from 'rxjs/operators';
import { AuthService } from '../shared/guards/auth.service';
import { Observable, of } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    })
};

@Injectable({
    providedIn: 'root'
})
export class SSOService {
    private ssourl = environment.ssourl;

    constructor(
        private http: HttpClient) {
    }

    CheckLogin(): Observable<any> {
        return this.http.get<string>(this.ssourl + "?action=login&type=user&requestType=json", httpOptions)
            .pipe(
                catchError(this.handleError<string>())
            );
    }

    GoToLogin(url: string) {
        if (url)
            window.location.href = this.ssourl + "?action=login&type=user&url=" + encodeURI(url);
        else
            window.location.href = this.ssourl + "?action=login&type=user";
    }

    LoginHref() {
        return this.ssourl + "?action=login&type=user";;
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
